import BaseModel from '../core/BaseModel';
import UserModel from '@/models/UserModel';

export default class ReferredHistoryModel extends BaseModel {
  constructor() {
    super(
      {
        name: 'referred_history',
        tableName: 'ref_history',
        label: 'Referred history',
      },
      {
        // item_id: {
        //   name: '',
        //   label: '',
        //   type: 'CheckboxItem',
        //   custom: 'CheckboxId',
        //   computed: (data) => {
        //     data.item_id = '';
        //   },
        //   class: 'center',
        //   width: 1,
        // },

        stt: {
          name: 'stt',
          label: 'No.',
          type: 'Computed',
          computed: (data, index) => {
            data.stt = index + 1;
          },
        },

        id: {
          name: 'id',
          type: 'Uuid',
          label: 'ID',
          primaryKey: true,
          display: false,
        },

        uid: {
          name: 'uid',
          type: 'Uuid',
          label: 'Uid',
          display: false,
        },
        
        ref_name_by_key: {
          name: 'ref_name_by_key',
          label: 'Referrer',
          type: 'Computed',
          computed: (data) => {
            data.ref_name_by_key = '';
          },
          filter: { type: 'input', match: 'contains' },
          class: 'left',
          width: 15,
        },

        user_name_by_key: {
          name: 'user_name_by_key',
          label: 'User',
          type: 'Computed',
          computed: (data) => {
            data.user_name_by_key = '';
          },
          class: 'left',
          filter: { type: 'input', match: 'contains' },
          width: 15,
        },

        order_code_by_key: {
          name: 'order_code_by_key',
          label: 'Order ID',
          type: 'Computed',
          computed: (data) => {
            data.order_code_by_key = '';
          },
          class: 'left',
          filter: { type: 'input', match: 'contains' },
          width: 15,
        },

        type: {
          name: 'type',
          label: 'Type',
          type: 'Selection',
          custom: 'SelectionText',
          options: [
            { value: 2, label: 'Rent', style: 'color:  #000000;' },
            { value: 3, label: 'Buy', style: 'color:  #000000;' },
          ],
          filter: {
            type: 'select',
            optionLabel: 'label',
            optionKey: 'value',
            match: 'equals',
          },
          class: 'left',
          width: 8,
        },

        order_amount: {
          name: 'order_amount',
          type: 'Number',
          label: 'Order amount',
          class: 'left',
        },

        earn_amount: {
          name: 'earn_amount',
          type: 'Number',
          label: 'Earn',
          class: 'left',
        },

        status: {
          name: 'status',
          label: 'Status',
          type: 'Selection',
          custom: 'SelectionText',
          options: [
            { value: 'New', label: 'New', style: 'color:  #000000;' },
            { value: 'Accepted', label: 'Accepted', style: 'color:  #000000;' },
            { value: 'Rejected', label: 'Rejected', style: 'color:  #000000;' },
          ],
          filter: {
            type: 'select',
            optionLabel: 'label',
            optionKey: 'value',
            match: 'equals',
          },
          class: 'center',
          width: 8,
        },

        payment_status: {
          name: 'payment_status',
          label: 'Payment status',
          type: 'Selection',
          custom: 'SelectionText',
          options: [
            { value: 'New', label: 'New', style: 'color:  #000000;' },
            { value: 'Paid', label: 'Paid', style: 'color:  #000000;' },
          ],
          filter: {
            type: 'select',
            optionLabel: 'label',
            optionKey: 'value',
            match: 'equals',
          },
          class: 'center',
          width: 8,
        },

        updated_by: {
          name: 'updated_by',
          type: 'Uuid',
          label: 'Updated By',
          display: false,
        },

        updated_by_key: {
          name: 'updated_by_key',
          label: 'Updated by',
          type: 'Computed',
          models: new UserModel(),
          computed: (data) => {
            data.updated_by_key = '';
          },
          class: 'left',
          width: 15,
        },

        updated_at: {
          name: 'updated_at',
          type: 'String',
          label: 'Updated date',
          width: 15,
        },

        created_at: {
          name: 'created_at',
          type: 'Datetime',
          label: 'Created At',
          display: false,
        },

        created_by: {
          name: 'created_by',
          type: 'Uuid',
          label: 'Created By',
          display: false,
        },

        deleted: {
          name: 'deleted',
          type: 'Boolean',
          label: 'Deleted',
          display: false,
        },
      }
    );
  }
}
